// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import SidebarMenu from './components/SidebarMenu';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import { TypingTest } from './pages/TypingTest';
import TypingResults from './pages/TypingResults';
import HomePage from './pages/HomePage';
import ClickSpeedTestPage from './pages/ClickTestsPage';
import ClickTestResults from './pages/ClickTestResults';
import ScrollToTop from './components/ScrollToTop';
import NotFoundPage from './pages/NotFoundPage'; 
import HigherOrLowerPage from './pages/HigherOrLowerPage';
import ColorMemoryPage from './pages/ColorMemoryPage';
import StopTheWheelPage from './pages/StopTheWheelPage';
import './styles/App.css';
import './styles/Results.css';

function AppRoutes() {
  // Google Analytics pageview tracking on route change
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }, []);

  return (
    <div className="app-container">
      <ScrollToTop />
      <SidebarMenu />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/15s-cpm-typing-test" element={<div className="page-margin"><TypingTest duration={15} /></div>} />
          <Route path="/30s-cpm-typing-test" element={<div className="page-margin"><TypingTest duration={30} /></div>} />
          <Route path="/60s-cpm-typing-test" element={<div className="page-margin"><TypingTest duration={60} /></div>} />
          <Route path="/3min-cpm-typing-test" element={<div className="page-margin"><TypingTest duration={180} /></div>} />
          <Route path="/5min-cpm-typing-test" element={<div className="page-margin"><TypingTest duration={300} /></div>} />
          <Route path="/15s-cpm-typing-test/results" element={<div className="page-margin"><TypingResults /></div>} />
          <Route path="/30s-cpm-typing-test/results" element={<div className="page-margin"><TypingResults /></div>} />
          <Route path="/60s-cpm-typing-test/results" element={<div className="page-margin"><TypingResults /></div>} />
          <Route path="/3min-cpm-typing-test/results" element={<div className="page-margin"><TypingResults /></div>} />
          <Route path="/5min-cpm-typing-test/results" element={<div className="page-margin"><TypingResults /></div>} />
          <Route path="/about-typing-clicking-tests" element={<div className="page-margin"><AboutPage /></div>} />
          <Route path="/privacy" element={<div className="page-margin"><PrivacyPage /></div>} />
          <Route path="/:testType/results" element={<TypingResults />} />
          <Route path="/1s-cps-click-test" element={<div className="page-margin"><ClickSpeedTestPage duration={1} /></div>} />
          <Route path="/5s-cps-click-test" element={<div className="page-margin"><ClickSpeedTestPage duration={5} /></div>} />
          <Route path="/15s-cps-click-test" element={<div className="page-margin"><ClickSpeedTestPage duration={15} /></div>} />
          <Route path="/30s-cps-click-test" element={<div className="page-margin"><ClickSpeedTestPage duration={30} /></div>} />
          <Route path="/60s-cps-click-test" element={<div className="page-margin"><ClickSpeedTestPage duration={60} /></div>} />
          <Route path="/click-test-results" element={<div className="page-margin"><ClickTestResults /></div>} />
          <Route path="/higher-or-lower" element={<HigherOrLowerPage />} />
          <Route path="/color-memory" element={<ColorMemoryPage />} />
          <Route path="/stop-the-wheel" element={<StopTheWheelPage />} />
          <Route path="*" element={<NotFoundPage />} /> 
        </Routes>
        <Footer />
      </main>
    </div>
  );
}

// Main App component with Router and Providers
export default function App() {
  // Initialize GA4 once
  useEffect(() => {
    ReactGA.initialize('G-2GBBHSVK33');
  }, []);
  
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  );
}